import React from 'react';
import ChatSidePanelCard from './ChatSidePanelCard';
import ChatSidePanelSummaryList from './ChatSidePanelSummaryList';

const resolveDateTimeLabel = (row, formatDate) => {
  const dateLabel = row?.date ? formatDate?.(row.date) : '日付未設定';
  const timeLabel = row?.time ? ` ${String(row.time).slice(0, 5)}` : '';
  return `${dateLabel}${timeLabel}`;
};

export default function AnnouncementSummarySidePanelCard({
  title,
  rows = [],
  isLoading = false,
  loadingLabel = '読み込み中...',
  emptyText = '',
  formatDate,
}) {
  const safeRows = Array.isArray(rows) ? rows : [];

  return (
    <ChatSidePanelCard title={title} count={!isLoading && safeRows.length ? safeRows.length : null}>
      <ChatSidePanelSummaryList
        rows={safeRows}
        isLoading={isLoading}
        loadingLabel={loadingLabel}
        emptyText={emptyText}
        renderRow={(row) => (
          <>
            <div className="side-name side-summary-title">
              <span className={`csp-status ${row.statusClass || ''}`}>
                {row.status}
              </span>
              {row.link ? (
                <a href={row.link} target="_blank" rel="noopener noreferrer" className="side-summary-link">
                  {row.name}
                </a>
              ) : (
                <span className="side-summary-link">{row.name}</span>
              )}
            </div>
            <div className="side-meta">{resolveDateTimeLabel(row, formatDate)}</div>
          </>
        )}
      />
    </ChatSidePanelCard>
  );
}
